import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const StkPushRequest = ()=>{
    const [stkPushRequest, setStkPushRequest] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`stkPushRequest?page=${page}`);
            setStkPushRequest(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`stkPushRequest/${id}`);
            setStkPushRequest(stkPushRequest.filter((stkPushRequest) => stkPushRequest.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'Stk Push Requests'}>
            <InnerNav createLink={'/stkPushRequestCreate'} listLink={'/stkPushRequest'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Time In </th>
                                    <th className="px-4 py-3">Phone</th>
                                    <th className="px-4 py-3">Amount </th>
                                    <th className="px-4 py-3">Trx Code</th>
                                    <th className="px-4 py-3">Result Desc </th>
                                    <th className="px-4 py-3">API Response </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {stkPushRequest && stkPushRequest.length > 0 ? (
                                         stkPushRequest.map((stkPushRequest)=>(
                                             <tr key={stkPushRequest.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{stkPushRequest.id}</td>
                                                 <td className="px-4 py-3 text-sm">{stkPushRequest.time_in}</td>
                                                 <td className="px-4 py-3 text-sm">{stkPushRequest.PhoneNumber}</td>
                                                 <td className="px-4 py-3 text-sm">{stkPushRequest.Amount}</td>
                                                 <td className="px-4 py-3 text-sm">{stkPushRequest.MpesaReceiptNumber}</td>
                                                 <td className="px-4 py-3 text-sm">{stkPushRequest.ResultDesc}</td>
                                                 <td className="px-4 py-3 text-sm">{stkPushRequest.Misc5}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/stkPushRequest/${stkPushRequest.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(stkPushRequest.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         ))
                                ) : (
                                            <tr>
                                                <td colSpan="8" className="text-center py-5 text-gray-500">No data to display </td>
                                            </tr>
                                         )}
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default StkPushRequest;